/* eslint-disable no-undef */
/* eslint-disable no-console */
import axios from 'axios';
import config from '../../../config';
import formattaData from '../../util';
import { bus } from '@/main';

const state = {
  image: [],
  associazione: [],
  associazioni: [],
  associazioniFiltrate: [],
};

const getters = {
  getAssociazioni: () => state.associazioniFiltrate,
  getAssociazione: () => state.associazione,
  getImage: () => state.image,
};

const actions = {
  loadAssociazione({ commit }, idItem) {
    axios
      .get(config.ROOT_API + '/api/associazioni/' + idItem)
      .then(function (response) {
        commit('setAssociazione', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setAssociazione', null);
      });
  },

  createAssociazione({ dispatch, commit }, newItem) {
    axios
      .post(config.ROOT_API + '/api/associazioni', newItem)
      .then(function (response) {
        commit('addAssociazione');
        dispatch('loadAssociazioni');
      })
      .catch((err) => {
        console.error(err);
      });
  },
  updateAssociazione({ dispatch, commit }, editItem) {
    // rimuovo l'immagine dall'oggetto associazione perchè è gestita con un servizio apposito
    delete editItem.image;
    axios
      .patch(config.ROOT_API + '/api/associazioni', editItem)
      .then(function (response) {
        commit('editAssociazione');
        dispatch('loadAssociazioni');
      })
      .catch((err) => {
        console.error(err);
      });
  },

  creaUserAssociazione({ dispatch, commit }, idItem) {
    // generazione utente per associato
    axios
      .patch(config.ROOT_API + '/api/associazioni/' + idItem + '/createAccessoResposabile')
      .then(function (response) {
        commit('editAssociazione');
        dispatch('loadAssociazioni');
      })
      .catch((err) => {
        console.error(err);
      });
  },

  updateUserAssociazione({ dispatch, commit }, idItem) {
    // generazione utente per associato
    axios
      .patch(config.ROOT_API + '/api/associazioni/' + idItem + '/updateAccessoResposabile')
      .then(function (response) {
        commit('editAssociazione');
        dispatch('loadAssociazioni');
      })
      .catch((err) => {
        console.error(err);
      });
  },

  deleteIndirizzoAssociazione({ dispatch, commit }, editItem) {
    axios
      .put(config.ROOT_API + '/api/associazioni', editItem)
      .then(function (response) {
        commit('removeIndirizzoAssociazione');
        dispatch('loadAssociazioni');
      })
      .catch((err) => {
        console.error(err);
      });
  },
  deleteAssociazioneAsync({ dispatch, commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .delete(config.ROOT_API + '/api/associazioni/' + item.id)
        .then(function (response) {
          dispatch('loadAssociazioni').then(() => {
            commit('removeAssociazione', response.data);
            resolve(response.data);
          });
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
  deleteAssociazione({ dispatch, commit }, item) {
    axios
      .delete(config.ROOT_API + '/api/associazioni/' + item.id)
      .then(function (response) {
        commit('removeAssociazione', response.data);
        setTimeout(function () {
          dispatch('loadAssociazioni');
        }, 500);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  deleteAssociazioniAsync({ dispatch, commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.ROOT_API + '/api/associazioni/removeassociazioni/', item.associazioniId)
        .then(function (response) {
          dispatch('loadAssociazioni').then(() => {
            commit('removeAssociazioni', response.data);
            resolve(response.data);
          });
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
  deleteAssociazioni({ dispatch, commit }, item) {
    axios
      .post(config.ROOT_API + '/api/associazioni/removeassociazioni/', item.associazioniId)
      .then(function (response) {
        commit('removeAssociazioni', response.data);
        setTimeout(function () {
          dispatch('loadAssociazioni');
        }, 500);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  loadAssociazioni({ commit }) {
    axios
      .get(config.ROOT_API + '/api/associazioni')
      .then(function (response) {
        commit('setAssociazioni', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setAssociazioni', null);
      });
  },
  loadImage({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/associazioni/' + itemId + '/image')
      .then(function (response) {
        commit('setImage', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('setImage', null);
      });
  },
  updateLogo({ commit }, data) {
    console.log(data);
    axios
      .post(config.ROOT_API + '/api/associazioni/' + data.id + '/image', data.uploadData)
      .then(function (response) {
        commit('editImage', response.data);
      })
      .catch((err) => {
        console.error(err);
        commit('editImage', null);
      });
  },

  filterCol({ dispatch, commit }, obj) {
    // filtra i risultati su una specifica colonna
    state.associazioniFiltrate = state.associazioni.filter((a) => {
      if (typeof a[obj.col] !== 'string') {
        // filtro per stato (attivo / non attivo / tutti)
        if (obj.val == 'all') {
          return true;
        } else {
          // eslint-disable-next-line
          return a[obj.col] == obj.val;
        }
      } else {
        return a[obj.col].toLowerCase().indexOf(obj.val.toLowerCase()) > -1;
      }
    });
  },
  search({ commit }, val) {
    // filtra i risultati su tutte le colonne
    if (val) {
      state.associazioniFiltrate = state.associazioni.filter((a) => {
        return JSON.stringify(a).toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }
  },
  exportIscrittiGTWEBXLS({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/associazioni/' + itemId + '/exportAssociatiInseriti')
      .then(function (response) {
        commit('exportIscrittiXLS', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  exportIscrittiAssociazioneXLS({ commit }, itemId) {
    axios
      .get(config.ROOT_API + '/api/associazioni/' + itemId + '/exportAssociati')
      .then(function (response) {
        commit('exportIscrittiXLS', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
  exportSagittaXLS({ commit }, completo) {
    axios
      .get(config.ROOT_API + '/api/associazioni/' + completo + '/exportSagitta')
      .then(function (response) {
        commit('exportSagittaXLS', response.data);
      })
      .catch((err) => {
        console.error(err);
      });
  },
};

const mutations = {
  addAssociazione(mdl) {
    window.getApp.$emit('ASSOCIAZIONE_CREATA');
    bus.$emit('associazioneDialog', false);
  },
  editAssociazione(mdl) {
    window.getApp.$emit('ASSOCIAZIONE_MODIFICATA');
    bus.$emit('associazioneDialog', false);
  },
  removeIndirizzoAssociazione(mdl) {
    window.getApp.$emit('INDIRIZZO_ASSOCIAZIONE_RIMOSSO');
  },
  setAssociazione(mdl, associazione) {
    state.associazione = associazione;
  },
  setAssociazioni(mdl, associazioni) {
    state.associazioni = associazioni;
    state.associazioniFiltrate = associazioni;
  },
  setImage(mdl, image) {
    state.image = image;
  },
  editImage(mdl) {
    window.getApp.$emit('IMMAGINE_AGGIORNATA');
  },
  removeAssociazione(mdl, item) {
    window.getApp.$emit('ASSOCIAZIONE_RIMOSSA');
    bus.$emit('deleteAssociazione', true);
  },
  removeAssociazioni(mdl, item) {
    window.getApp.$emit('ASSOCIAZIONI_RIMOSSE');
    bus.$emit('deleteAssociazione', true);
  },
  exportIscrittiXLS(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },

  exportSagittaXLS(mdl, data) {
    const blob = new Blob([Buffer.from(data.blobData).buffer]);
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob, {
      type: 'data:attachment/xlsx',
    });
    const fname = data.fileName;
    link.download = fname;
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(link.href);
  },
  importAssociatiXls(mdl, message) {
    window.getApp.$emit('IMPORT_EFFETTUATO');
    if (message != '') {
      bus.$emit('erroreClassifica', message);
    } else {
      bus.$emit('classificaUploaded', true);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
